module.exports = __webpack_public_path__ + "img/right2Line.c9c789ef.png";